import { useQuery } from '@tanstack/react-query';
import { useQueryCreator } from '~/hooks/useQueryCreator';
import { fulfillmentContextService } from '~/services';
import type { PartnerLaneOrchestration } from '@shipium-corp/shipium-ts-types';
import { DOCK_LANE_QUERY_KEY } from './dockLaneQueryKeys';

export { DOCK_LANE_QUERY_KEY };

const dockLaneQuery = {
  queryKey: DOCK_LANE_QUERY_KEY,
  configurationType: 'default' as const,
  fn: (laneId: string): Promise<PartnerLaneOrchestration> => fulfillmentContextService.fetchDockLane(laneId),
};

export const useDockLane = (laneId: string | undefined) => {
  return useQuery({
    ...useQueryCreator(dockLaneQuery, {
      args: [laneId!],
    }),
    enabled: !!laneId,
  });
};
